import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getExecution } from '../Api'

export default generateApiAction({
  baseType: Types.EXECUTIONS.GET,
  api: getExecution,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/executions/GetAction.js